window.kentico = window.kentico || {}
window.kentico._forms = window.kentico._forms || {}

window.kentico._forms.formFileUploaderComponent = (function (document) {
  function disableElements (form) {
    form.fileUploaderDisabledElements = []
    const elements = form.elements
    for (let i = 0; i < elements.length; i++) {
      const element = elements[i]
      if (!element.disabled) {
        form.fileUploaderDisabledElements.push(i)
        element.disabled = true
      }
    }
  }

  function enableElements (form) {
    form.fileUploaderDisabledElements.forEach(function (disabledElement) {
      form.elements[disabledElement].disabled = false
    })
  }

  function clearTempFile (
    fileInput,
    inputReplacementFilename,
    inputPlaceholder,
    tempFileIdentifierInput,
    inputTextButton,
    inputIconButton
  ) {
    fileInput.value = null
    fileInput.removeAttribute('hidden')
    inputReplacementFilename.setAttribute('hidden', 'hidden')

    inputPlaceholder.innerText = inputPlaceholder.originalText
    tempFileIdentifierInput.value = ''

    inputTextButton.setAttribute('hidden', 'hidden')
    inputIconButton.setAttribute('data-icon', 'select')
    inputIconButton.removeAttribute('title')
  }

  function attachScript (config) {
    const fileInput = document.getElementById(config.fileInputId)
    const inputPlaceholder = document.getElementById(
      config.fileInputId + '-placeholder'
    )
    const inputReplacementFilename = document.getElementById(
      config.fileInputId + '-replacement'
    )
    const inputTextButton = document.getElementById(
      config.fileInputId + '-button'
    )
    const inputIconButton = document.getElementById(config.fileInputId + '-icon')

    const tempFileIdentifierInput = document.getElementById(
      config.tempFileIdentifierInputId
    )
    const systemFileNameInput = document.getElementById(
      config.systemFileNameInputId
    )
    let originalFileNameInput = document.getElementById(
      config.originalFileNameInputId
    )
    const deletePersistentFileInput = document.getElementById(
      config.deletePersistentFileInputId
    )
    const tempFileOriginalName = config.tempFileOriginalName

    const deleteFileIconButtonTitle = config.deleteFileIconButtonTitle

    inputPlaceholder.originalText = inputPlaceholder.innerText
    inputTextButton.originalText = inputTextButton.innerText

    // If a file is selected, set text of the label and file input replacement to its filename.
    if (
      (originalFileNameInput.value || tempFileOriginalName) &&
      deletePersistentFileInput.value.toUpperCase() === 'FALSE'
    ) {
      inputPlaceholder.innerText =
        config.originalFileNamePlain || tempFileOriginalName

      inputTextButton.removeAttribute('hidden')
      inputIconButton.setAttribute('data-icon', 'remove')
      inputIconButton.setAttribute('title', deleteFileIconButtonTitle)

      inputReplacementFilename.removeAttribute('hidden')
      fileInput.setAttribute('hidden', 'hidden')
    }

    // If file has not yet been persisted, send a request to delete it.
    const deleteTempFile = function () {
      if (tempFileIdentifierInput.value) {
        const deleteRequest = new XMLHttpRequest()

        deleteRequest.open(
          'POST',
          config.deleteEndpoint +
            '&tempFileIdentifier=' +
            tempFileIdentifierInput.value
        )
        deleteRequest.send()
      }
    }

    // Deletes both permanent and temp files.
    const deleteFile = function () {
      if (systemFileNameInput.value) {
        deletePersistentFileInput.value = true
      }

      deleteTempFile()

      clearTempFile(
        fileInput,
        inputReplacementFilename,
        inputPlaceholder,
        tempFileIdentifierInput,
        inputTextButton,
        inputIconButton
      )
    }

    // Wrapper for the deleteFile function used when the icon button is clicked.
    const deleteFileIcon = function (event) {
      if (inputIconButton.getAttribute('data-icon') === 'remove') {
        event.preventDefault()
        deleteFile()
      }
    }

    inputTextButton.addEventListener('click', deleteFile)
    inputIconButton.addEventListener('click', deleteFileIcon)

    fileInput.addEventListener('change', function () {
      // In IE11 change fires also when setting fileInput value to null.
      if (!fileInput.value) {
        return
      }

      inputTextButton.removeAttribute('hidden')
      inputIconButton.setAttribute('data-icon', 'loading')
      disableElements(fileInput.form)

      // Validate file size.
      const file = fileInput.files[0]
      if (file !== undefined) {
        if (file.size > config.maxFileSize * 1024) {
          fileInput.value = null
          tempFileIdentifierInput.value = ''
          originalFileNameInput = ''

          window.alert(config.maxFileSizeExceededErrorMessage)
          enableElements(fileInput.form)
          inputIconButton.setAttribute('data-icon', 'select')

          return
        }
      }

      const data = new FormData()
      const submitRequest = new XMLHttpRequest()
      submitRequest.contentType = 'multipart/form-data'

      data.append('file', file)

      submitRequest.addEventListener('load', function (e) {
        if (submitRequest.readyState === 4) {
          if (submitRequest.status === 200) {
            let result = submitRequest.response
            // IE11 and Edge do not support response type 'json'
            if (typeof result === 'string') {
              result = JSON.parse(result)
            }

            if (result.errorMessage) {
              fileInput.value = null
              alert(result.errorMessage)

              inputIconButton.setAttribute('data-icon', 'select')
              inputTextButton.setAttribute('hidden', 'hidden')
            } else {
              if (systemFileNameInput.value) {
                deletePersistentFileInput.value = true
              }
              deleteTempFile()

              const filename = fileInput.files[0].name

              tempFileIdentifierInput.value = result.fileIdentifier

              inputPlaceholder.innerText = filename
              inputTextButton.removeAttribute('hidden')
              inputIconButton.setAttribute('data-icon', 'remove')
              inputIconButton.setAttribute('title', deleteFileIconButtonTitle)

              inputReplacementFilename.innerText = filename
              inputReplacementFilename.removeAttribute('hidden')
              fileInput.setAttribute('hidden', 'hidden')
            }
          } else {
            alert('Error sending file: ' + submitRequest.statusText)

            inputIconButton.setAttribute('data-icon', 'select')
            inputTextButton.setAttribute('hidden', 'hidden')
          }

          inputTextButton.innerHTML = inputTextButton.originalText
          enableElements(fileInput.form)
        }
      })

      submitRequest.upload.addEventListener('progress', function (event) {
        inputTextButton.innerText =
          parseInt((event.loaded / event.total) * 100) + '%'
      })

      submitRequest.open('POST', config.submitEndpoint)
      submitRequest.responseType = 'json'
      submitRequest.send(data)
    })
  }

  return {
    attachScript
  }
})(document)
